import { takeEvery, put, all } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import apiFetcher from '../../tools/api-fetcher';
import formDataEncode from '../../tools/form-data-encode';
import handleError from '../../tools/error-helper';

import * as types from '../../actions/candidate/candidate-application-documents/types';
import * as actions from '../../actions/candidate/candidate-application-documents';

function* getCandidateApplicationDocuments({ applicationId }) {
  yield put(actions.setFormLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get(
        `/candidates/current/applications/${applicationId}/documents/summaries`
      );

    yield put(actions.setCandidateApplicationDocuments(data));
  } catch (exception) {
    handleError(exception, `Failed to load application documents.`);
  }

  yield put(actions.setFormLoading(false));
}

function* deleteCandidateApplicationDocument({ applicationId, documentId }) {
  yield put(actions.setDocumentRemoving(true));

  try {
    yield apiFetcher
      .auth()
      .delete(
        `/candidates/current/applications/${applicationId}/documents/${documentId}`
      );
      yield toastr.success('Application document was successfully deleted.'); 
  } catch (exception) {
    handleError(exception, `Failed to delete application document.`);
  }

  yield put(actions.setDocumentRemoving(false));
}

function* updateCandidateApplicationDocument({
  applicationId,
  documentId,
  document
}) {
  yield put(actions.setDocumentUpdating(true));

  try {
    yield apiFetcher
      .auth()
      .put(
        `/candidates/current/applications/${applicationId}/documents/${documentId}`,
        formDataEncode(document)
      );
      yield toastr.success('Application document was successfully updated.');      
  } catch (exception) {
    handleError(exception, `Failed to update application document.`);
  }

  yield put(actions.setDocumentUpdating(false));
}

function* addCandidateApplicationDocument({
  applicationId,
  virtualDocumentId,
  document
}) {
  yield put(actions.setDocumentAdding(true));

  try {
    const { data: documentId } = yield apiFetcher
      .auth()
      .post(
        `/candidates/current/applications/${applicationId}/documents`,
        formDataEncode(document)
      );

    yield put(
      actions.setNewCandidateApplicationDocument({
        virtualDocumentId: virtualDocumentId,
        documentId: documentId
      })
    );
    yield toastr.success('Application document was successfully added.');
  } catch (exception) {
    handleError(exception, `Failed to add application document.`);
  }

  yield put(actions.setDocumentAdding(false));
}

export default function* candidateApplicationDocumentsSaga() {
  yield all([
    takeEvery(
      types.CANDIDATE_APPLICATION_DOCUMENTS_GET_SUMMARIES,
      getCandidateApplicationDocuments
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_DOCUMENTS_DELETE_DOCUMENT,
      deleteCandidateApplicationDocument
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_DOCUMENTS_UPDATE_DOCUMENT,
      updateCandidateApplicationDocument
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_DOCUMENTS_ADD_DOCUMENT,
      addCandidateApplicationDocument
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-application-documents.js